<div class="wrapper">
	<div class="text-container" role="region" aria-label="Text content">
		<ion-row role="region" aria-label="Content section">
			<ion-col>
				<h3>{{ 'custom_tip.title' | translate }}</h3>
			</ion-col>
		</ion-row>
		<ion-row>
			<ion-col>
				<ion-item lines="none">
					<ion-label>€</ion-label>
					<ion-input
						class="primary-input"
						(keypress)="numberOnlyValidation($event)"
						[(ngModel)]="customTip"
						placeholder="{{ 'custom_tip.input_placeholder' | translate }}"
					></ion-input>
				</ion-item>
			</ion-col>
		</ion-row>
	</div>
	<ion-row>
		<ion-col class="button-block">
			<ion-button class="button" (click)="dismiss()">
				{{ 'custom_tip.button_cancel' | translate }}
			</ion-button>
			<ion-button class="button" (click)="addCustomTip()">
				{{ 'custom_tip.button_ok' | translate }}
			</ion-button>
		</ion-col>
	</ion-row>
</div>
